import React from "react";
export default function RecoveryGapNote({message}){
  return <div role="note" style={{margin:"8px 0",padding:"10px 12px",borderRadius:8,
    border:"1px solid #E8D7AB",background:"#FFF8E8",color:"#735823",fontSize:12,
    lineHeight:1.5,overflowWrap:"anywhere"}}>
    <strong style={{display:"block",marginBottom:3}}>Aviso de histórico incompleto</strong>
    {message.texto}
  </div>;
}
